import React, { useContext, useEffect, useState } from 'react';
import moment from 'moment';
import { Button, Input, Radio, Row, Space, Tabs, Typography } from 'antd';
import { AuthenticationContext } from 'src/providers/AuthenticationContext';
import { SetAccessToken } from 'src/config/ApiConfig';
import { useLocalStorage } from 'src/hooks';
import './HomePage.less';
import type { TabsProps } from 'antd';
import CRMLookUP from '../components/CRMLookup';
import LocationData from '../components/LocationData';

const HomePage: React.FC = () => {
    const [loadingTableData, setLoadingTableData] = useState(false);
    const authContext = useContext(AuthenticationContext);
    const [loadingAPIData, setLoadingAPIData] = useState(false);

    // Dec 2022, password: 5586449c-1f4e-4111-93e8-b1b72a0bb69e
    const handlePasswordChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const passwordValue = event.target.value;
        // Persist to the authContext
        await authContext.updatePassword(passwordValue);
    };
    
    const tabItems: TabsProps['items'] = [
        {
            label: 'CRM Lookup',
            key: '1',
            children: <CRMLookUP loadingTableData={loadingTableData} setLoadingTableData={setLoadingTableData}></CRMLookUP>
        },
        {
            label: 'Location Data',
            key: '2',
            children: <LocationData loadingData={loadingAPIData} setLoadingData={setLoadingAPIData}></LocationData>
        }
    ];
    return (
        <div className='home-page'>
            <div className='password-section'>
                <Space size={16}>
                    <Typography.Text strong>Password:</Typography.Text>
                    <Input
                        style={{ width: 300 }}
                        placeholder='Password'
                        disabled={loadingTableData || loadingAPIData }
                        value={authContext.password}
                        onChange={handlePasswordChange}
                    />
                </Space>
            </div>
            <br />
            <Tabs animated defaultActiveKey="1" items={tabItems}></Tabs>
        </div>
    );
};

export default HomePage;
